import { styled } from "styled-components";

export const NovoCriativoContainer = styled.form`
  width: calc(100% - 260px);
  display: flex;
  justify-content: center;
  border-radius: 40px;

  .box {
    padding: 50px;
    width: 100%;
    min-height: 400px;
    background-color: var(--base01);
    border-radius: 30px;

    .voltar {
      svg {
        width: 45px;
        height: 45px;
        cursor: pointer;
      }
    }

    h1 {
      font-size: 50px;
      font-weight: 600;
      margin-left: 10px;
      color: var(--principal);
    }

    .underline {
      font-size: 14px;
      margin-left: 10px;
      text-decoration: underline;
      color: var(--principal);
    }

      button {
        background-color: var(--amarelo);
        color: var(--principal);
        border: none;
        padding: 5px;
        border-radius: 20px;
        width: 10%;
        font-size: 0.8rem;
        font-weight: 600;
      }
    }

    .flex{
      align-items: center;
    }

    .div-files{
    display: flex;
    gap: 40px;
    width: 100%;
    flex-wrap: wrap;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 40px;

  .checkbox input {
    display: none;
  }

  .checkbox input + label:before {
    content: "";
    width: 15px;
    height: 15px;
    border-radius: 2px;
    border: 1px solid #979696;
    vertical-align: middle;
    display: inline-block;
    margin-left: 5px;
    margin-right: 5px;
    cursor: pointer;
  }

  .checkbox input:checked + label:before {
    background-image: url("data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 10 10'%3E%3Cg class='nc-icon-wrapper' stroke-width='1' fill='%23555555'%3E%3Cpath fill='none' stroke='%23FFFFFF' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='10' data-cap='butt' d='M2.83 4.72l1.58 1.58 2.83-2.83'/%3E%3C/g%3E%3C/svg%3E");
    background-color: var(--amarelo);
  }

  .checkbox label {
    font-size: 0.9rem;
  }

  h2 {
    margin: 20px 0px 30px 0px;
  }

  > label {
    margin-bottom: 10px;
    font-size: 0.8rem;
  }

  > input {
    border: none;
    background-color: var(--base);
    padding: 10px;
    border-radius: 6px;
    font-size: 0.8rem;
    outline: none;
  }
`;

export const Inputs = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 10px 0 10px 0;
  gap: 50px;
  > div {
    display: flex;
    flex-direction: column;
    width: 100%;

    > label, .label {
      margin-bottom: 10px;
      font-size: 1rem;
      font-weight: 600;
    }

    > input,
      select,
      textarea {
      border: none;
      background-color: var(--base);
      padding: 10px;
      border-radius: 6px;
      font-size: 0.8rem;
      outline: none;
      min-width: 100%;
      max-height: 300px;
    }
  }

  .div-files{
    display: flex;
    gap: 40px;
    width: 100%;
    flex-wrap: wrap;
    margin-top: 20px;
  }

  .relative-file{
    position: relative;
    
    span{
      position: absolute;
      top: -10px;
      right: -15px;
      cursor: pointer;
      color: red;
      font-size: 20px;
      font-weight: 700;
    }
  }

  .column{
    display: flex;
    flex-direction: column;
  }

  .label-file{
    padding: 10px;
    border: 2px dashed #878282; 
    border-radius: 5px;
    background-color: white;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 5px auto;
    width: 100%;
    color: var(--principal);
    text-decoration: underline;
  }
`;
